module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webapp-wrapper"
  }, [_c('div', {
    staticClass: "other"
  }, [_c('div', {
    class: _vm.getWidthClass,
    attrs: {
      "dir": _vm.currentLangDirection,
      "id": "wrapper"
    }
  }, [_c('span', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.currentState))]), _vm._v(" "), _c('div', {
    staticClass: "langs btn-group btn-group-xs",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    class: _vm.lang === 'en' || _vm.lang === '' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('en')
      }
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('button', {
    class: _vm.lang === 'es' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('es')
      }
    }
  }, [_vm._v("Español")]), _vm._v(" "), _c('button', {
    class: _vm.lang === 'fr' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('fr')
      }
    }
  }, [_vm._v("Français")]), _vm._v(" "), _c('button', {
    class: _vm.lang === 'ar' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('ar')
      }
    }
  }, [_vm._v("العربية")]), _vm._v(" "), _c('button', {
    class: _vm.lang === 'ru' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('ru')
      }
    }
  }, [_vm._v("русский")])]), _vm._v(" "), (_vm.$store.getters.getShowSlide) ? _c('div', [_c('slide-page')], 1) : _c('div', {
    staticClass: "content"
  }, [(_vm.$store.getters.getLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")]), _vm._v(" "), (_vm.$store.getters.getStillLoading) ? _c('div', {
    staticClass: "loading-takes-long"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Loading is taking longer than normal')) + "\n            "), _c('a', {
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setLoading', false);
        _vm.$events.emit('goToPageEvent', '')
      }
    }
  }, [_vm._v("Go home")])]) : _vm._e()]) : _c('div', {
    staticClass: "notloading"
  }, [_c('message-items'), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.$store.getters.getShowGoTo,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.$store.commit('setShowGoTo', false)
      }
    }
  }, [_c('go-to-box', {
    attrs: {
      "title": _vm.goToModalData.title,
      "message": _vm.goToModalData.message,
      "targetUrl": _vm.goToModalData.url
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.$store.getters.getShowShare,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.$store.commit('setShowShare', false)
      }
    }
  }, [_c('share-page')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.$store.getters.getSocialLogin,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.$store.commit('setShowSocialLogin', false)
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('Social Login')))]), _vm._v(" "), _c('fb-login')], 1)], 1)]), _vm._v(" "), ((_vm.$store.getters.getCurrentPage != 'login' && _vm.$store.getters.getCurrentPage != '' && _vm.$store.getters.getCurrentState != '' && _vm.$store.getters.getCurrentPage != 'signup')) ? _c('div', {
    staticClass: "top-container"
  }, [_c('div', {
    staticClass: "top-menu"
  }, [_c('div', {
    staticClass: "logout-area"
  }, [_c('button', {
    staticClass: "btn btn-plain btn-back",
    style: (_vm.langDirection == 'rtl' ? 'float:right' : 'float:left'),
    on: {
      "click": _vm.goToPrevPage
    }
  }, [(_vm.langDirection == 'rtl') ? _c('i', {
    staticClass: "fa fa-angle-right fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })]), _vm._v(" "), _c('span', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.getMyBalance))]), _vm._v(" "), _c('div', {
    style: (_vm.langDirection == 'rtl' ? 'float:left' : 'float:right')
  }, [_c('logout-button')], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [(_vm.$store.getters.getCurrentState == 'login' || _vm.$store.getters.getCurrentState == '') ? _c('div', {
    staticClass: "login-area"
  }, [(_vm.$store.getters.getCurrentPage == 'login' || _vm.$store.getters.getCurrentPage == '') ? _c('div', [_c('login-form')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'signup') ? _c('div', [_c('signup-form')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'signupPOS') ? _c('div', [_c('signup-pos-form')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'share') ? _c('div', [_c('share-page')], 1) : _vm._e()]) : _c('div', {
    staticClass: "loggedin-area"
  }, [_c('div', {}, [(_vm.$store.getters.getCurrentPage == 'home' || _vm.$store.getters.getCurrentPage == '') ? _c('div', [_c('home-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'share') ? _c('div', [_c('share-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'associations') ? _c('div', [_c('associations-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'asso_details') ? _c('div', [_c('association-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'donations') ? _c('div', [_c('donations-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'transactions') ? _c('div', [_c('transactions-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'subscription') ? _c('div', [_c('subscription-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'qrCode') ? _c('div', [_c('qr-code-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'map') ? _c('div', [_c('map-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'admin-page') ? _c('div', [_c('admin-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'supportive-pos') ? _c('div', [_c('supportive-pos-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'solidarity') ? _c('div', [_c('solidarity-account-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'settings') ? _c('div', [_c('settings-page')], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-menu"
  }, [_c('label', {
    class: _vm.$store.getters.getAppMode == 'test' ? 'test-mode version' : 'version'
  }, [_c('span', {
    on: {
      "click": _vm.updateVNCC
    }
  }, [_vm._v("Version: " + _vm._s(_vm.$store.getters.getVersion))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#EEE"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters.getVNCC))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowSlides', true);
        return false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o fa-fw"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.helpLink
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('Help')) + "\n            ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1062a6bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 297
// module chunks = 1